import { MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';

export const ContactUrgency = ({ handleWhatsAppClick }) => (
<div className="urgency-band text-center bg-gradient-to-r from-red-900/50 via-red-800/50 to-red-900/50 p-12 rounded-2xl border-2 border-red-600/60">
              <h3 className="text-3xl font-bold text-yellow-400 mb-4">
                🔥 Situation Urgente ? Consultation Immédiate !
              </h3>
              <p className="text-gray-200 mb-8 text-lg leading-relaxed">
                Pour toute urgence nécessitant une intervention rapide du sorcier vaudou Maître Diamma 
                (retour affectif urgent, désenvoutement immédiat, protection d'urgence), 
                contactez-le maintenant sur WhatsApp. Réponse et début des rituels dans les plus brefs délais.
              </p>
              <Button 
                data-testid="urgent-whatsapp-button"
                onClick={handleWhatsAppClick}
                size="lg"
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-lg md:text-2xl px-12 md:px-16 py-6 md:py-8 transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-green-500/50 font-bold flex items-center justify-center"
              >
                <MessageCircle className="w-6 h-6 md:w-7 md:h-7 mr-3 flex-shrink-0" />
                <span>WhatsApp Urgent</span>
              </Button>
              <p className="mt-6 text-gray-400">
                ⚡ Intervention possible sous 24h • Confidentialité totale • Paiement après résultats
              </p>
            </div>
);
